import { render, staticRenderFns } from "./MinimizedVideoChat.vue?vue&type=template&id=17f49f5b&scoped=true"
import script from "./MinimizedVideoChat.vue?vue&type=script&lang=ts"
export * from "./MinimizedVideoChat.vue?vue&type=script&lang=ts"
import style0 from "./MinimizedVideoChat.vue?vue&type=style&index=0&id=17f49f5b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17f49f5b",
  null
  
)

export default component.exports